module.exports = __webpack_public_path__ + "static/media/OrderNow.3d4ff8b4.png";